import { FieldTypes } from '../../../constants/FieldTypes'
import { Field, FieldMap } from '../../../types/forms/fields'
import {
  declineToAnswerField,
  getBooleanHistoryField,
  getPleaseSpecifyField,
  notApplicableField,
} from '../../shared'

const currentlyActiveFields: Record<string, Field> = {
  currentlyActive: getBooleanHistoryField(
    'Are you currently sexually active, or have you been in the past 12 months?',
  ),
  relationshipTypes: {
    type: FieldTypes.MULTIPLE_SELECT,
    placeholder: 'Type of relationship with partner(s)',
    condition: v => !!v?.currentlyActive,
    options: [
      {
        text: 'Monogamous',
        id: 'monogamous',
      },
      {
        text: 'Open',
        id: 'open',
      },
      {
        text: 'Multiple',
        id: 'multiple',
      },
      {
        text: 'Polyamorous',
        id: 'polyamorous',
      },
      {
        text: 'Other',
        id: 'other',
      },
    ],
  },
  relationshipTypesOther: {
    type: FieldTypes.TEXT,
    placeholder: 'Please specify',
    condition: v => !!v?.currentlyActive && v?.relationshipTypes?.includes('other'),
  },
  numberOfPartners: {
    type: FieldTypes.NUMBER,
    placeholder: 'In the past 12 months, how many sexual partners have you had?',
    condition: v => !!v?.currentlyActive,
  },
}

const wantsToAnswerProviderQuestionsFields: Record<string, Field> = {
  wantsToAnswerProviderQuestions: getBooleanHistoryField(
    'Do you want to answer specific questions about the type(s) of sex you are having? This can be helpful for your provider to know.',
  ),
  sexualBehaviorTypesToDiscuss: {
    type: FieldTypes.MULTIPLE_SELECT,
    placeholder: 'Check all that apply',
    options: [
      {
        text: 'Vaginal penetrative',
        id: 'vaginal-penetrative',
      },
      {
        text: 'Anal penetrative',
        id: 'anal-penetrative',
      },
      {
        text: 'Oral',
        id: 'oral',
      },
      {
        text: 'Other',
        id: 'other',
      },
    ],
    condition: v => !!v?.wantsToAnswerProviderQuestions,
  },
}

const usesProtectionFields: Record<string, Field> = {
  usesProtection: getBooleanHistoryField(
    'Do you and your current partner(s) use protection against STIs (sexually transmitted infections)?',
  ),
  usesProtectionMethods: {
    type: FieldTypes.TEXTAREA,
    placeholder: 'What type of protection do you and your current partner(s) use?',
    condition: v => !!v?.usesProtection,
  },
}

const usesBirthControlFields: Record<string, Field> = {
  usesBirthControl: getBooleanHistoryField('Do you and your current partner(s) use birth control?'),
  usesBirthControlMethods: {
    type: FieldTypes.TEXTAREA,
    placeholder: 'What type of birth control do you and your current partner(s) use?',
    condition: v => !!v?.usesBirthControl,
  },
}

const concernsAboutSexualBehaviorFields: Record<string, Field> = {
  hasConcernsAboutSexualBehavior: getBooleanHistoryField(
    'Do you have any concerns or problems about your sexual pleasure, drive pain, or dislike of sex?',
  ),
  concernsAboutSexualBehaviorDescription: {
    type: FieldTypes.TEXTAREA,
    placeholder: 'What are your concerns or problems regarding your sexual behavior?',
    condition: v => !!v?.hasConcernsAboutSexualBehavior,
  },
  concernsAboutSexualBehaviorTimeline: {
    type: FieldTypes.TEXTAREA,
    placeholder: 'When did these concerns or problems start?',
    condition: v => !!v?.hasConcernsAboutSexualBehavior,
  },
  concernsAboutSexualBehaviorObject: {
    type: FieldTypes.TEXTAREA,
    placeholder: 'Is the object of your concern the time, place or your partner(s)?',
    condition: v => !!v?.hasConcernsAboutSexualBehavior,
  },
  concernsAboutSexualBehaviorDrive: {
    type: FieldTypes.TEXTAREA,
    placeholder: 'Is there a loss of sex drive or dislike of sexual contact?',
    condition: v => !!v?.hasConcernsAboutSexualBehavior,
  },
  concernsAbouSexualBehaviorRelationships: {
    type: FieldTypes.TEXTAREA,
    placeholder: 'Are there problems in your relationship(s)?',
    condition: v => !!v?.hasConcernsAboutSexualBehavior,
  },
}

const anythingToDiscussFields: Record<string, Field> = {
  anythingToDiscuss: getBooleanHistoryField(
    'Is there anything about your sexuality or sexual relationships you would like to discuss?',
  ),
  anythingToDiscussDetails: getPleaseSpecifyField('anythingToDiscuss', true),
}

export const sexualBehaviorField: FieldMap = {
  name: 'Sexual Behavior',
  children: {
    notApplicable: notApplicableField,
    declineToAnswer: declineToAnswerField,
    ...currentlyActiveFields,
    ...wantsToAnswerProviderQuestionsFields,
    ...usesProtectionFields,
    ...usesBirthControlFields,
    ...concernsAboutSexualBehaviorFields,
    ...anythingToDiscussFields,
  },
}
